<template>
    <div>
        <div class="col-lg-11 col-md-12 viewercards row no-gutters mt-lg-4" >
            <div class="col-12 mt-lg-2" >
                <div class="col-lg-12 mt-3">
                    <div class="d-flex">
                        <div class="d-flex col-6">
                            <span class="fontsm proximanova fontbold mt-2 mr-lg-3 mr-1">Billing Country</span>
                            <select name="billingCountry" class="pl-lg-3 pr-lg-3 col-7" id="billingCountry" v-model="billingCountry" @change="getStatesList">
                                <option value="USA">USA</option>
                                <option value="India">India</option>
                            </select>
                        </div>
                        <div class="col-6 d-flex">
                            <span class="fontsm proximanova fontbold mr-lg-3 mt-2 mr-1">State</span>
                            <multiselect
                                v-model="selectedMultiselectBillingState"
                                class="multiselect multiselectInput-create"
                                :options="billingStatesList"
                                label="stateName"
                                :multiple="false"
                                :close-on-select="true"
                                :clear-on-select="true"
                                :hide-selected="true"
                                :preserve-search="true"
                                track-by="stateName"
                                @select="onSelectBillingState"
                                placeholder="Select State"
                                :show-labels="false">
                            </multiselect>
                        </div>
                    </div>
                </div>
                <div class="col-11 ml-3 mt-lg-3 mt-2">
                    <span class="fontsize16 proximanova black fontbold">Checkout</span>
                </div>
                <div class="card ml-3 mr-3 mt-3 pb-3" v-if="savedCardsList.length > 0">
                    <div class="sectionheader d-flex pl-3 pr-3 p-2 borderbottom" >
                        <div class="col-6 pl-0 pr-0"><span class="fontsm black proximanova" :class="{'black30' :savedCardsList.length<1}">Your saved credit and debit cards</span></div>
                        <div class="col-3 pl-0 pr-0"><span class="fontsm black proximanova" :class="{'black30' :savedCardsList.length<1}">Name on the card</span></div>
                        <div class="col-2 pl-0 pr-0"><span class="fontsm black proximanova" :class="{'black30' :savedCardsList.length<1}">Expires on</span></div>
                        <div class="col-2 pl-0 pr-0"></div>
                    </div>
                    <div>
                        <div v-for="(card , index) in savedCardsList" :key="index" class="pt-2">
                            <div class="d-flex  pl-3 pr-3">
                                <div class="d-flex col-6 pl-0 pr-0">
                                    <div class="pt-2 pointer">
                                        <input type="radio" :id="'reason'+card.paymentId" name="reportvideoprofile" :value="card.paymentId" class="mt-1" v-model="storedPaymentId">
                                    </div>
                                    <div class="d-flex col-10 pl-0 pr-0 flex-column">
                                        <div class="d-flex col-12 pr-0 flex-column ml-2 pb-2 pt-1 pointer mouseoveranimate" @click="selectExistingCard(card)">
                                            <label class="fontsize14 black proximanova fontbold mb-0 pointer" :for="'reason'+card.paymentId" :class="{'activeCard' :card.paymentId === storedPaymentId}">VISA</label>
                                            <span class="fontsm black60 proximanova">{{card.decCardNum}}</span>
                                        </div>
                                        <div class="mb-1 ml-4" v-if="card.paymentId === storedPaymentId">
                                            <span class="fontsm proximanova linearcolors fontbold">Primary Account</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3 pl-0 pr-0 pt-1">
                                    <span class="fontsm black80 proximanova">{{card.decCardHN}}</span>
                                </div>
                                <div class="col-2 pl-0 pr-0 pt-1">
                                    <span class="fontsm black80 proximanova">{{card.decCardEM}}/{{card.decCardEY}}</span>
                                </div>
                                <div class="col-2 pl-0 pr-0"></div>
                            </div>
                            <div class="borderbottom mt-2" v-if="index < savedCardsList.length-1"></div>
                        </div>
                        <div class="pl-3 pr-3">
                            <div class="borderbottom mt-2 mb-2 " ></div>
                        </div>
                        <div class="d-flex pl-3 pr-3" @click="AddNewCardInformation">
                            <input type="radio" :id="'newcard'" name="reportvideoprofile" value="true"  class="mt-1" v-model="addNewCrdDetails">
                            <label class="font12-opacity50 ml-3 pointer" for='newcard'>Add New Card information</label>
                        </div>
                    </div>
                </div>
                <div class="card ml-3 mr-3 mt-2 mt-lg-3" v-if="addNewCrdDetails">
                    <div class="cardbody d-md-flex d-lg-flex">
                        <div class="paymentoptions1 borderbottom pt-1 pb-1 d-block d-md-none">
                            <div class="d-flex">
                                <div class="p-2 mt-lg-1 mb-lg-1">
                                    <span class="p-2 font12-opacity50 text-nowrap" :class="{'cardsection':cardPaymentsection}">Debit / Credit card</span>
                                </div>
                                <div class="p-2 mt-lg-1 mb-lg-1">
                                    <span class="p-2 font12-opacity50 text-nowrap">Net Banking</span>
                                </div>
                                <div class="p-2 mt-lg-1 mb-lg-1">
                                    <span class="p-2 font12-opacity50 text-nowrap">UPI</span>
                                </div>
                                <div class="p-2 mt-lg-1 mb-lg-1">
                                    <span class="p-2 font12-opacity50 text-nowrap">QR Code</span>
                                </div>
                            </div>
                        </div>
                        <div class="paymentoptions d-none d-md-block">
                            <div class="d-flex flex-column">
                                <div class="borderbottom p-2 mt-lg-1 mb-lg-1">
                                    <span class="p-2 font12-opacity50" :class="{'cardsection':cardPaymentsection}">Debit / Credit card</span>
                                </div>
                                <div class="borderbottom p-2 mt-lg-1 mb-lg-1">
                                    <span class="p-2 font12-opacity50">Net Banking</span>
                                </div>
                                <div class="borderbottom p-2 mt-lg-1 mb-lg-1">
                                    <span class="p-2 font12-opacity50">UPI</span>
                                </div>
                                <div class="borderbottom p-2 mt-lg-1 mb-lg-1">
                                    <span class="p-2 font12-opacity50">QR Code</span>
                                </div>
                            </div>
                        </div>
                        <div class="paymentprocess p-4 pb-5">
                            <div class="cardpayment">
                                <span class="font12-bold pl-lg-4 ml-1">We accept</span>
                                <div class="d-flex flex-column pl-lg-4 mt-3">
                                    <span class="p-1 font12-opacity50">Card Details</span>
                                    <div class="p-1 mb-1 text-left">
                                        <input 
                                            type="text" 
                                            data-vv-as="Card Number" 
                                            v-validate=" 'required' "
                                            :name="'Card Number'" required
                                            data-vv-scope="CardDetails" 
                                            @input="ValidateCreditCardNumber"
                                            maxlength="16" 
                                            v-model="cardNumber" 
                                            class="paycard" 
                                            placeholder="Card Number"
                                        >
                                        <div v-if="errors.has('CardDetails.Card Number')" class="alert-danger"
                                            >{{ errors.first('CardDetails.Card Number') }}</div>
                                        <div v-else>
                                            <div v-if="!validcardNum" class="alert-danger"> Invalid Card Number</div>
                                        </div>
                                    </div>
                                    <div class="p-1 mb-1">
                                        <input 
                                            type="text" 
                                            data-vv-as="Card Holder Name" 
                                            v-validate=" 'required' "
                                            :name="'Card Holder Name'" required
                                            @input="formValidation"
                                            data-vv-scope="CardDetails" 
                                            class="paycard" 
                                            v-model="cardHolderName" 
                                            placeholder="Cardholder Name"
                                        >
                                        <div v-if="errors.has('CardDetails.Card Holder Name')" class="alert-danger"
                                            >{{ errors.first('CardDetails.Card Holder Name') }}</div>
                                    </div>
                                    <div class="subsec p-1 d-flex justify-content-between">
                                        <span class="d-flex flex-column">
                                            <div class="d-flex">
                                                <select 
                                                    data-vv-as="Expiry Month/Year" 
                                                    v-validate=" 'required' "
                                                    :name="'Expiry Month/Year'" required
                                                    data-vv-scope="CardDetails"
                                                    @change="formValidation"
                                                    class="paycard2" 
                                                    style="width:45%" 
                                                    id="month" 
                                                    v-model="expiryMonth" >
                                                    <option value="" disabled>MM</option>
                                                    <option :value="month.value" v-for="(month, index) in monthsList" :key="index">{{month.value}}</option>
                                                </select>
                                                                        
                                                <select 
                                                    class="paycard2" 
                                                    data-vv-as="Expiry Month/Year" 
                                                    v-validate=" 'required' "
                                                    :name="'Expiry Month/Year'" required
                                                    @change="formValidation"
                                                    data-vv-scope="CardDetails"
                                                    id="month" 
                                                    style="width:55%" 
                                                    v-model="expiryYear" >
                                                    <option value="" disabled>YYYY</option>
                                                    <option :value="year" v-for="(year, index) in yearsList" :key="index">{{year}}</option>
                                                </select>
                                            </div>
                                            <div v-if="errors.has('CardDetails.Expiry Month/Year')" class="alert-danger"
                                                >{{ errors.first('CardDetails.Expiry Month/Year') }}</div>
                                        </span>
                                        <div class="cardcvv">
                                            <input 
                                                type="text" data-vv-as="CVV" 
                                                v-validate=" 'required' "
                                                :name="'CVV'" required
                                                @input="formValidation"
                                                data-vv-scope="CardDetails"
                                                class="paycard1 p-1" 
                                                maxlength="4" 
                                                v-model="cvv" 
                                                placeholder="CVV"
                                            >
                                            <div v-if="errors.has('CardDetails.CVV')" class="alert-danger"
                                                >{{ errors.first('CardDetails.CVV') }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-11 ml-3 mt-lg-3 mt-2" v-if="!clickonFreeTrail">
                    <span class="fontsize16 proximanova black fontbold">Summary</span>
                </div>
                <div class="card ml-3 mr-3 p-2 pl-3 pr-3 mt-3" v-if="!clickonFreeTrail">
                    <div class="d-flex justify-content-between p-1">
                        <div class="p-2">
                            <span class="fontsize16 black proximanova">Monthly Plan Subscription</span>
                        </div>
                        <div class="pull-right mt-2">
                            <button class="freetrailbtn ml-2" @click="movetochangePlanSection">Change plan</button>
                        </div>
                    </div>
                    <div class="borderbottom"></div>
                    <div class="d-flex justify-content-between p-2">
                        <span class="fontsm black80 proximanova">Original Price</span>
                        <span class="fontsm black80 proximanova">${{originalPrice}}</span>
                    </div>
                    <div class="borderbottom"></div>
                    <div class="d-flex justify-content-between p-2">
                        <span class="fontsm black80 proximanova">Service Tax - 8.25%</span>
                        <span class="fontsm black80 proximanova">${{SeriviceTax}}</span>
                    </div>
                    <div class="borderbottom"></div>
                    <div class="d-flex justify-content-between p-2">
                        <span class="fontsm black80 proximanova fontbold">Total Amount</span>
                        <span class="fontsm black80 proximanova fontbold">${{payableAmount}}</span>
                    </div>
                </div>
                <div class="card ml-3 mr-3 mt-3">
                    <div class="d-lg-flex d-md-flex justify-content-between">
                        <div class="p-2 ml-lg-4 mt-3">
                            <span class="font12Italic">Payment will consider after 30 days of your free trail</span>
                        </div>
                        <div class="pull-right p-3">
                            <button class="button-cancel1 modalbtn" @click="movetochangePlanSection">cancel</button>
                            <button class="starttrailbtn sign-up-button ml-2 pl-4 pr-4" v-if="!payBtnClicked" :disabled="paymentbtnDisabled" id="paybutton" @click="cardPayment" >Pay</button>
                            <img src="../assets/uploadvideo.svg" v-if="payBtnClicked" class="ml-4 mr-4" width="33px" alt="uploading">
                        </div>
                    </div>
                </div>       
            </div>
        </div>
    </div>
</template>
<script>
import httpuserprofile from "../js/http-userprofile.js"
import DatePicker from 'vue2-datepicker';
import monthsList from '../js/wn_data.json'
import router from '../router.js'
import httppayment from "@/js/http-payment.js";
import moment from 'moment'
import cryptoscript from '@/js/cryptoscript.js'
import sessionUtils from '@/js/session-util.js'
import { bus } from "../main";
export default {
    components: {
        DatePicker
    },
    props : [
        'dataSharingObject'
    ],
    data(){
        return {
            currentUser : null,
            currentUserId : null,
            currentUserProfileId : null,
            payableAmount : 10,
            monthsList : null,
            yearsList : null,
            clientEmail : '',
            clientId : '',
            clickonFreeTrail : false,
            paymentsection : false,
            remainingDaysLeft : null,
            freeTrailAccess : null,
            cardPaymentsection : true,
            // slashadded : false,
            storedPaymentId : null,
            addNewCrdDetails : false,
            billingCountry : 'USA',
            billingStatesList : [],
            selectedMultiselectBillingState : null,
            billingStateName : null,
            currentUserDetails : null,
            currencyType : 'USD',
            originalPrice : '8',
            SeriviceTax : '2',
            paymentFrequency : 'Monthly',
            validcardNum : true,
            cardNumber : null,
            cardHolderName : null,
            expiryMonth : '',
            expiryYear : '',
            expiryDate : '',
            cvv : null,
            remembermyCard : 'N',
            paymentbtnDisabled : true,
            payBtnClicked : false,
            paymentSuccessful : false,
            savedCardsList : [
                {
                    paymentId: 15,
                    paymentScheduledDate: "2021-Jul-17",
                    lastPaymentDate: "",
                    active: "Y",
                    cardDetails: {
                        cardType: null,
                        nameOnCard: "Jagadeesh",
                        cardNetwork: null,
                        cardNumber: "4242424242424242",
                        expiryMonth: "2",
                        expiryYear: "2023",
                        securityCode: "789",
                        billingAddress: null
                    }
                },
            ],
        }
    },
    
    methods: {
        AddNewCardInformation(){
            this.addNewCrdDetails = true;
            this.storedPaymentId = null;
            console.log(this.addNewCrdDetails)
        },
        selectExistingCard(card){
            this.addNewCrdDetails = false;
            this.storedPaymentId = card.paymentId;
            console.log(this.storedPaymentId)
        },
        cardPayment() {
            this.payBtnClicked = true;
            //payment schedule date calculation
            const d = new Date();
            if(this.remainingDaysLeft > 0 && this.freeTrailAccess === 'Y'){
                d.setDate(d.getDate() + this.remainingDaysLeft);
                console.log(d)
            }else{
                d.setDate(d.getDate() + 1);
                console.log(d)
                this.payBtnClicked = true;
            }
            let scheduleDate  = moment(d).format("YYYY-MMM-DD");
            console.log(scheduleDate)
            let encCardNum = ''
            let encCardHolName = ''
            let encExpiryMonth = ''
            let encExpiryYear = ''
            let encCvv = ''
            if(this.storedPaymentId === null) {
                encCardNum = this.cardNumber
                encCardHolName = this.cardHolderName
                encExpiryMonth = this.expiryMonth
                encExpiryYear = this.expiryYear
                encCvv = this.cvv
            }
            // //card details encryption
            // let encCardNum = cryptoscript.encrypt(this.cardNumber)
            // let encCardHolName = cryptoscript.encrypt(this.cardHolderName)
            // let encExpiryMonth = cryptoscript.encrypt(this.expiryMonth)
            // let encExpiryYear = cryptoscript.encrypt(this.expiryYear)
            // let encCvv = cryptoscript.encrypt(this.cvv)
            // console.log("card number : ", this.cardNumber, encCardNum)
            // console.log("cardHolderName : ", this.cardHolderName, encCardHolName)
            // console.log("expmonth : ", this.expiryMonth,  encExpiryMonth)
            // console.log("expiryyear : ", this.expiryYear, encExpiryYear)
            // console.log("cvv : ", this.cvv, encCvv)
            let paymentObj = {
                amount : this.payableAmount,
                storedPaymentId : this.storedPaymentId,
                cardDetails : {
                    billingAddress : {
                        addressLine1 : '',
                        addressLine2 : '',
                        addressType : '',
                        city : '',
                        country : this.billingCountry,
                        postalCode : '',
                        state : this.billingStateName,
                    },
                    cardNumber : encCardNum,
                    expiryMonth : encExpiryMonth,
                    expiryYear : encExpiryYear,
                    nameOnCard : encCardHolName,
                    securityCode : encCvv
                },
                clientEmail : this.clientEmail,
                clientId : this.clientId,
                clientName : '',
                currency : this.currencyType,
                customerDetails : {
                    customerId : this.currentUserDetails.profileId,
                    email : this.currentUserDetails.email,
                    firstName : this.currentUserDetails.firstName,
                    lastName : this.currentUserDetails.lastName,
                    phoneNumber : this.currentUserDetails.primaryPhoneNumber
                },
                loggedInUser : this.currentUserDetails.fullName,
                paymentFrequency : this.paymentFrequency,
                scheduledPaymentDate : scheduleDate
            }
            console.log(paymentObj)

            // let decCardNum = cryptoscript.decrypt(encCardNum)
            // let decCardHolName = cryptoscript.decrypt(encCardHolName)
            // let decExpiryMonth = cryptoscript.decrypt(encExpiryMonth)
            // let decExpiryYear = cryptoscript.decrypt(encExpiryYear)
            // let decCvv = cryptoscript.decrypt(encCvv)
            // console.log("card number : ", this.cardNumber, decCardNum)
            // console.log("cardHolderName : ", this.cardHolderName, decCardHolName)
            // console.log("expmonth : ", this.expiryMonth,  decExpiryMonth)
            // console.log("expiryyear : ", this.expiryYear, decExpiryYear)
            // console.log("cvv : ", this.cvv, decCvv)
            // httppayment.post('/payment/schedulepayment',paymentObj)
            // .then((response) => {
            //     console.log("success : ", response)
            //     this.payBtnClicked = false;
            //     this.paymentsection = false;
            //     this.paymentSuccessful = true;
            //     this.clearPaymentInfo()
            //     // this.StartTrail()
            // }).catch((e) => {
            //     console.log("error : ", e.response)
            //     this.payBtnClicked = false;
            // })
        },
        getSavedCards(){
            httppayment.get('/payment/retrieveStoredPayments?customerId='+this.currentUserProfileId)
            .then((response) => {
                console.log("stored cards : ", response)
                let List = response.data.storedPaymentDetails
                if(List.length > 0){
                    for(var i=0; i < 1; i++){
                        console.log("enter")
                        let cardN = cryptoscript.decrypt(List[i].cardDetails.cardNumber)
                        cardN = "Ending on "+cardN.substr(12)
                        List[i].decCardNum = cardN;
                        List[i].decCardHN = cryptoscript.decrypt(List[i].cardDetails.nameOnCard)
                        List[i].decCardEM = cryptoscript.decrypt(List[i].cardDetails.expiryMonth)
                        List[i].decCardEY = cryptoscript.decrypt(List[i].cardDetails.expiryYear)
                        this.savedCardsList.push(List[i])
                        console.log("savedcards : ", this.savedCardsList)
                    }
                }
            }).catch((e) => {
                consolelog(e)
            })
        },
        //this will invoke after successfully submitted payment information
        clearPaymentInfo(){
            this.cardNumber = null;
            this.cardHolderName = null;
            this.expiryMonth = '';
            this.expiryYear = '';
            this.expiryDate = '';
            this.cvv = null;
            this.remembermyCard = 'N';
        },
        //this will invoke after key enter in card number input field to validate card Number
        ValidateCreditCardNumber() {
            var ccNum = this.cardNumber;
            var visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
            var mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
            var amexpRegEx = /^(?:3[47][0-9]{13})$/;
            var discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
            var isValid = false;

            if (visaRegEx.test(ccNum)) {
                isValid = true;
                console.log("visa")
            } else if(mastercardRegEx.test(ccNum)) {
                isValid = true;
                console.log("master")
            } else if(amexpRegEx.test(ccNum)) {
                isValid = true;
                console.log("amer")
            } else if(discovRegEx.test(ccNum)) {
                isValid = true;
                console.log("discov")
            }

            if(isValid) {
                console.log("Thank You!");
                this.validcardNum = true;
            } else {
                console.log("Please provide a valid Visa number!");
                this.validcardNum = false;
            }
            this.formValidation()
        },
        //this will invoke after enter enter value in each input field to enable and disable the submit button
        formValidation(){
            this.$validator.validateAll("CardDetails").then((isValid) => {
                if(isValid){
                    console.log("check1")
                    this.paymentbtnDisabled = false;
                    document.getElementById("paybutton").classList.add("sign-in-button");
                } else {
                    console.log("check")
                    this.paymentbtnDisabled = true;
                    document.getElementById("paybutton").classList.remove("sign-in-button");
                }
                    
            })
        },
        FreetrailAccess :function() {
            console.log("free trail access")
            this.clickonFreeTrail = true;
            this.paymentSuccessful = false;
        },
        movetochangePlanSection : function() {
            bus.$emit('openChangePlanSection', 'test');
        },
        StartTrail : function() {
            var vm = this;
            httpuserprofile.post('/userprofile/savePremiumData',
            {
                profileId: this.currentUserProfileId,
                trailAccountFlag:"Y",
                premiumAccountFlag:"",
                accountType:"trail"
            }).then((response) => {
                console.log("free trail : ", response)
                vm.$toast.success(response.data)
            }).catch((e) => {
                console.log(e)
            })
        },
        //this will invoke after selecting state from dropdown list
        onSelectBillingState(option){
            console.log(option)
            this.billingStateName = option.stateName
        },
        //this will invoke after change the country in dropdown
        getStatesList() {
            this.billingStatesList = [];
            this.selectedMultiselectBillingState = null;
            this.billingStateName = null
            var countryCode = null
            if(this.billingCountry === 'USA'){
                countryCode = 2
            }else{
                countryCode = 1
            }
            console.log(countryCode)
            httpuserprofile.get("searchController/getStatesList", {
                params: { countryCode: countryCode }
            })
            .then(response => {
                this.billingStatesList = response.data;
                console.log(response.data);
            }).catch((e) => {
                console.log(e.response)
            })
        },
        //this will invoke after loading the component
        getUserData() {
            httpuserprofile.get('/userprofile/userbyid/'+sessionUtils.getUserId())
            .then(response =>{
                console.log(response)
                this.currentUserDetails = response.data
                this.currentUserDetails.fullName = this.currentUserDetails.firstName + ' ' + this.currentUserDetails.lastName
            }).catch((e) => {
                console.log(e.response)
            })
        },
        setPropsData(){
            this.SeriviceTax =  this.dataSharingObject.SeriviceTax
            this.originalPrice = this.dataSharingObject.originalPrice
            this.currencyType = this.dataSharingObject.currencyType
            this.paymentFrequency = this.dataSharingObject.paymentFrequency
            this.billingCountry = this.dataSharingObject.billingCountry
            this.payableAmount = this.dataSharingObject.payableAmount
        }
    },
    created(){        
        window.scrollTo(0, 0);
        this.currentUserId = sessionUtils.getUserId();
        this.currentUserProfileId = sessionUtils.getUserProfileId()
        this.remainingDaysLeft = this.$store.state.remainingDays
        this.freeTrailAccess = this.$store.state.trailAccountFlag
        this.monthsList = monthsList.monthsList;
        this.yearsList = monthsList.yearsList;
        this.clientEmail = monthsList.clientEmail;
        this.clientId = monthsList.clientId;
        console.log("in same project dataSharingObject : ", this.dataSharingObject)
        this.setPropsData()
        this.getUserData()
        // this.getSavedCards()
    },
    destroyed() {
    }
}
</script>
<style scoped>
@import '../css/vue-multiselect.min.css';
html,
body,
.grid {
    height: 100%;
    width: 100%;
}

.viewercards{
    padding-left: 0 !important;
    padding-right: 0 !important;
}
.header {
    position: fixed;
    width: 100%;
    z-index: 10;
    background: #ffffff;
    border-bottom: 2px solid rgba(219, 219, 219,1);
}
.card-header {
    padding: 5px 10px 5px 10px;
    margin-bottom: 0;
    border: 1px solid #d9dce1;
    opacity: 0.6;
    border-radius: 8px;
}
.cardsection{
    color: #007AFF;
}
.card-header1 {
    border: 1px solid #d9dce1;
    opacity: 0.6;
    border-radius: 8px;
}
.paycard {
    border: none;
    border: 1px solid rgba(31, 31, 31, 0.1);
    width: 100%;
    text-align: left;
    padding: 6px;
    border-radius: 5px;
    color: rgba(31, 31, 31, 0.7);
}
.modalbtn {
  transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
}
.modalbtn::before{
  transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px;
  margin-top: -1px;
	background-color :  rgba(29, 27, 27, 0.3);
}
.modalbtn:hover::before{
  transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
.subsec{
    width: 100%;
}
#billingCountry{
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 5px 10px 5px 10px;
    height: 38px;
    background: none;
    color: black;
}
select{
    border: 1px solid rgba(31, 31, 31, 0.1);
    border-radius: 5px;
    font-family: "Proxima Nova Regular";
    color: rgba(31, 31, 31, 0.3);
    color: rgba(31, 31, 31, 0.7);
}
.carderror{
    border: 1px solid red;
}
select:focus{
    outline: none;
}
.datepicker{
    border: 1px solid rgba(31, 31, 31, 0.1);
    width: 39%;
    border-radius: 5px;
    color: rgba(31, 31, 31, 0.3);
    color: rgba(31, 31, 31, 0.7);
}
.proximanova{
    margin-top: 2px;
}
.multiselect__tags{
    background: none !important;
}
.multiselect{
    border-bottom: 1px solid rgba(31, 31, 31, 0.1) !important;
}
.multiselectInput-create {
  font-size: 18px;
  padding: 0 0 0 0;
  display: block;
  width: 100%;
  border-radius: 5px;
  border: 1px solid rgba(31, 31, 31, 0.1);
}
.paycard1{
    border: 1px solid rgba(31, 31, 31, 0.1);
    width: 100%;
    padding: 6px;
    border-radius: 5px;
    color: rgba(31, 31, 31, 0.3);
    color: rgba(31, 31, 31, 0.7);
}
.cardcvv{
    width: 39%;
}
.paycard2{
    border: 1px solid rgba(31, 31, 31, 0.1);
    width: 26%;
    padding: 6px;
    border-radius: 5px;
    color: rgba(31, 31, 31, 0.3);
    color: rgba(31, 31, 31, 0.7);
}
.paycard2:focus{
    border: 1px solid rgba(31, 31, 31, 0.1);
}
.paycard:focus{
    border: 1px solid rgba(31, 31, 31, 0.1);
}
.paycard1:focus{
    border: 1px solid rgba(31, 31, 31, 0.1);
}
.cardpayment{
    width: 100%;
}
.hotizonline {
    border-bottom: 1px solid #DDE0E6;
}
.button-cancel1 {
  border: 1px solid #1f1f1f;
  background: none;
  opacity: 0.3;
  border-radius: 4px;
  padding: 5px 10px;
  /* transition: border 8s; */
}
.starttrailbtn {
    border: none;
    padding: 6px 10px;
    font-size: 16px;
    border-radius: 4px;
}
.paymentoptions {
    background: rgba(240, 242, 245, 0.6);
    border-right: 1px solid rgba(31, 31, 31, 0.1);
    width: 30%;
}
.paymentoptions1{
    background: rgba(240, 242, 245, 0.6);
}
.borderbottom {
    border-bottom: 1px solid rgba(31, 31, 31, 0.1);
}
.cardbody{
    /* border-bottom:  1px solid rgba(31, 31, 31, 0.1); */
    border-radius: 10px;
}
.benifits{
    margin-left: -1em;
}
.benifits li{
    padding: .25em;
}
input:focus,
textarea:focus {
    outline: none; /** For Safari, etc **/
    border: transparent;
}
.card {
  border: 3px solid #F0F2F5;
  border-radius: 10px;
  background-color: #ffffff;
}
.backbtn {
    margin-top: -8px;
}
.premium {
    /* border: 1px solid #FF7676; */
    border: 3px solid #0078ff;
}
.premiumbtn{
    cursor: pointer;
}
.font12Italic {
    font-size: 12px;
    font-family: "Proxima Nova Regulrar";
    font-style: italic;
    font-weight: bold;
    color: rgba(31, 31, 31, 0.8);
}
.followbtn {
    border: none;
    background-color: rgba(31, 31, 31,.04);
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}
</style>
